































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { displayColorCalculoRecebimentoBySituation, maskDate, onlyNumber } from '@/utils/common'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { RequestMessage, SituacaoRemuneracaoCalculadoEnum, IRequestMessage } from '@/types/_'

@Component
export default class ViewFinanceiroTabelaAmb extends Vue {
  getRequestMessage: IRequestMessage = new RequestMessage()
  showModalEdit: boolean = false
  showModalDelete: boolean = false
  showModalCriarItem: boolean = false
  loadCreate: boolean = false
  loadSave: boolean = false
  loadDelete: boolean = false
  createCodigoAMB: string = ''
  createCodigoTuss: string = ''
  createDescricaoTuss: string = ''
  search: string = ''
  edit: any = {
    id: '',
    codigoTuss: '',
    descricaoTuss: '',
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get headersTabelaAMB() {
    return this.getFinanceiroStore.headersTabelaAMB
  }

  get tabelasAMB() {
    return this.getFinanceiroStore.tabelasAMB
  }

  set tabelasAMB(value: any) {
    this.getFinanceiroStore.tabelasAMB = value
  }

  get tabelaId() {
    return this.getFinanceiroStore.tabelaId
  }

  set tabelaId(value: any) {
    this.getFinanceiroStore.setTabelaId(value)
  }

  get codigoAMB() {
    return this.getFinanceiroStore.codigoAMB
  }

  set codigoAMB(value: any) {
    this.getFinanceiroStore.setCodigoAMB(value)
  }

  get itemUpdateId() {
    return this.getFinanceiroStore.itemUpdateId
  }

  set itemUpdateId(value: any) {
    this.getFinanceiroStore.setItemUpdateId(value)
  }

  get descricaoTussUpdate() {
    return this.getFinanceiroStore.descricaoTuss
  }

  set descricaoTussUpdate(value: any) {
    this.getFinanceiroStore.setDescricaoTuss(value)
  }

  get codigoTussUpdate() {
    return this.getFinanceiroStore.codigoTuss
  }

  set codigoTussUpdate(value: any) {
    this.getFinanceiroStore.setCodigoTuss(value)
  }

  get tabelaAMBIdUpdate() {
    return this.getFinanceiroStore.tabelaAmbId
  }

  set tabelaAMBIdUpdate(value: any) {
    this.getFinanceiroStore.setTabelaAmbId(value)
  }

  get edited() {
    return this.edit
  }

  set edited(value: any) {
    this.edit = value
  }

  get itemsTabelaAmb() {
    return this.getFinanceiroStore.itemsTabelaAmb
  }

  set itemsTabelaAmb(value: any) {
    this.getFinanceiroStore.setItemsTabelaAmb(value)
  }

  get loadingSave() {
    return this.loadSave
  }

  set loadingSave(value: boolean) {
    this.loadSave = value
  }

  get loadingCreate() {
    return this.loadCreate
  }

  set loadingCreate(value: boolean) {
    this.loadCreate = value
  }

  get loadingDelete() {
    return this.loadDelete
  }

  set loadingDelete(value: boolean) {
    this.loadDelete = value
  }

  get pagination() {
    return this.getFinanceiroStore.pagination
  }

  get pages() {
    if (this.pagination.rowsPerPage === null || this.pagination.totalItems === null) return 0
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  clearCreateFields() {
    this.createCodigoAMB = ''
    this.createCodigoTuss = ''
    this.createDescricaoTuss = ''
  }

  editItem(item) {
    this.itemUpdateId = item.id
    this.tabelaAMBIdUpdate = item.tabelaAMBId
    this.codigoAMB = item.codigoAMB
    this.edited = Object.assign({}, item)
    this.showModalEdit = true
  }

  deleteItem(item) {
    this.itemUpdateId = item.id
    this.showModalDelete = true
  }

  criarItem() {
    this.showModalCriarItem = true
  }

  async selectTabela(item: any) {
    this.tabelaId = item
    await this.$nextTick(() => {
      this.filter()
    })
  }

  async filter() {
    this.getFinanceiroStore.clearPagePagination()
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    await this.getFinanceiroStore.getItemsTabelaAMB()
    EventBus.$emit('clearLoadingRequest')
  }

  async deleteTableItem() {
    this.loadingDelete = true
    const response = await this.getFinanceiroStore.deleteItemTabelaAmb()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item excluído com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getFinanceiroStore.getItemsTabelaAMB()
      this.closeModalDelete()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível excluir o item!', icon: 'warning', color: '#C62828' })
    }
    this.loadingDelete = false
  }

  async saveTableItem() {
    this.loadingSave = true
    this.descricaoTussUpdate = this.edited.descricaoTuss
    this.codigoTussUpdate = this.edited.codigoTuss
    const response = await this.getFinanceiroStore.updateItemTabelaAmb()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item atualizado com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getFinanceiroStore.getItemsTabelaAMB()
      this.closeModalEdit()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível atualizar a tabela!', icon: 'warning', color: '#C62828' })
    }
    this.loadingSave = false
  }

  async createTableItem() {
    this.loadingCreate = true
    this.codigoAMB = this.createCodigoAMB
    this.codigoTussUpdate = this.createCodigoTuss
    this.descricaoTussUpdate = this.createDescricaoTuss
    this.tabelaAMBIdUpdate = this.tabelaId
    const response = await this.getFinanceiroStore.createItemTabelaAmb()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item criado com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getFinanceiroStore.getItemsTabelaAMB()
      this.closeModalCriar()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível criar o item!', icon: 'warning', color: '#C62828' })
    }
    this.loadingCreate = false
  }

  closeModalEdit() {
    this.showModalEdit = false
  }

  closeModalDelete() {
    this.showModalDelete = false
  }

  closeModalCriar() {
    this.clearCreateFields()
    this.showModalCriarItem = false
  }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: this.getRequestMessage.status, text: this.getRequestMessage.init.text })
    this.tabelaId = ''
    this.clearCreateFields()
    await this.getFinanceiroStore.getTabelasAMB()
    EventBus.$emit('clearLoadingRequest')
  }

  async mounted() {
    await this.init()
  }
}
